module.exports = __webpack_public_path__ + "static/sungrown-lot-b73eeba782417f66d32bcdab6a9c43b2.jpg";